@if (isNavigating()) {
  <div class="nav-progress-bar"></div>
}
<div class="app-container">
  <main class="app-content">
    <router-outlet></router-outlet>
  </main>
</div>
